import React, { useState, useRef, useEffect } from "react";
import ProfileIcon from "../../../../Assets/svg/user.svg";
import { BsChevronDown } from "react-icons/bs";
import profileStyles from "./Profile.module.css";
import ProfileMenu from "../ProfileMenu/ProfileMenu";

// import Drawer from "@mui/material/Drawer";
// import Login from "../../../Login/Login";
// import VerifyOtp from "../../../Login/VerifyOtp";
// import {
//   selecttoken,
//   selectloginSlider,
//   setloginSliderstate,
//   selectVerifySlider,
//   setVerifyOtpSliderstate,
//   selectOnCloseDisableLoginSlider
// } from "../../../../src/slice/LoginPageSlice";
import { useDispatch, useSelector } from "react-redux";

const Profile = () => {
  const profileRef = useRef(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const dispatch = useDispatch();
  // const loginSlider = useSelector(selectloginSlider);
  // const verifySlider = useSelector(selectVerifySlider);
  // const onCloseLoginSliderDeactive = useSelector(selectOnCloseDisableLoginSlider);

  const handleProfileClick = () => {
    // console.log("clicked on profile");
    try {
      const userDetails = JSON.parse(localStorage.getItem("user"));
      const token = userDetails && userDetails?.token;
      if (token) {
        setShowProfileMenu(true);
      } else {
        window.location.href = process.env.RAZZLE_APP_BASE_URL;
        // dispatch(setloginSliderstate(true));
      }
    }
    catch {
      // console.log("Token Not Found")
    }
  };

  return (
    <>
      <div
        className={profileStyles.header_profileSection}
        onBlur={() => {
          setTimeout(() => {
            setShowProfileMenu(false);
          }, 200);
        }}
        ref={profileRef}
      >
        <img src={ProfileIcon} className={profileStyles.profileIcon} />
        <span
          onClick={handleProfileClick}
          className={profileStyles.profileText}
        >
          &nbsp;Profile
          <BsChevronDown className={profileStyles.dropDownIcon} />
        </span>
        {showProfileMenu ? (
          <div className={profileStyles.dropDownlist}>
            <ProfileMenu
              showProfileMenu={showProfileMenu}
              setShowProfileMenu={setShowProfileMenu}
              menuAnchorEl={profileRef.current}
              menuFontSize="1rem"
            />

            {/* <ToggleMenu
            setCartLength={setCartLength}
            isLoginfun={setLogin}
          /> */}
          </div>
        ) : null}
      </div>
      {/* <Drawer
        anchor="right"
        open={loginSlider}
        onClose={() => {
          if (onCloseLoginSliderDeactive) {
            console.log("Cannot close slider")
          } else {
            dispatch(setloginSliderstate(false));
          }
        }}
      >
        <Login />
      </Drawer>
      <Drawer
        anchor="right"
        open={verifySlider}
        onClose={() => dispatch(setVerifyOtpSliderstate(false))}
      >
        <VerifyOtp />
      </Drawer> */}
    </>
  );
};

export default Profile;
